import { Provider } from '@angular/core';

import { UserService } from '@core/services/user.service';

export const CORE_PROVIDERS: Provider[] = [UserService];
